import { atom } from 'recoil';

export const toastMessageState = atom<any>({
  key: "toastMessageState",
  default:[],
});
